import Button from '../../components/Button/Button';
import { CheckIcon } from '../../components/icons/CheckIcon';
import { CloseCircleIconV2 } from '../../components/icons/CloseCircleIconV2';
import styles from './FormButtons.module.scss';

export const FormButtons = ({
  onCancel,
  loading,
  cancelButtonProps,
  submitButtonProps,
  className = '',
  onlyIcons,
}) => {
  return (
    <div className={`d-flex align-stretch justify-content-between gap-3 ${className}`}>
      <Button
        type="button"
        // variant="outline"
        color="light"
        className={`w-100 ${styles.button}`}
        onClick={onCancel}
        disabled={loading}
        {...cancelButtonProps}>
        {onlyIcons ? <CloseCircleIconV2 width={32} /> : 'Cancel'}
      </Button>
      <Button
        type="submit"
        className={`w-100 ${styles.button}`}
        loading={loading}
        color="warning"
        {...submitButtonProps}>
        {onlyIcons ? <CheckIcon width={32} /> : 'Save'}
      </Button>
    </div>
  );
};
